import React, { useRef, useEffect } from 'react';
import { useIntl } from 'react-intl';
import Button from '@starbucks-web/pattern-library/lib/components/button';
import Heading from '@starbucks-web/pattern-library/lib/components/heading';
import chevronLeft from '@starbucks-web/pattern-library/lib/icons/chevron-left';
import Icon from '@starbucks-web/pattern-library/lib/components/icon';

import ColumnsTemplate from '../../columns-template';
import { usePdpContext } from '../../pdp-provider';
import CallsToAction from './calls-to-action';
import CustomizationCategory from './customization-category';
import messages from './messages';
import styles from '../styles.cssm';

const Customizations = () => {
  const { formatMessage } = useIntl();
  const backButtonRef = useRef(null);
  const {
    product: { productOptions },
    setIsCustomizing,
  } = usePdpContext();

  const numberOfCategories = productOptions.length;
  const firstColumnEndIndex = Math.ceil(numberOfCategories / 2);

  useEffect(() => {
    backButtonRef.current?.focus();
  }, []);

  const sliceCategoriesIntoColumns = (startIndex, endIndex) => {
    return productOptions.slice(startIndex, endIndex).map((category) => {
      const categoryName = category.name;

      return (
        <React.Fragment key={`${category.categoryNumber}-${categoryName}`}>
          <Heading bottomBorder className="pt3 pb3" size="md" tagName="h2">
            {categoryName}
          </Heading>
          <CustomizationCategory
            category={category}
            key={`${category.categoryNumber}-${categoryName}`}
          />
        </React.Fragment>
      );
    });
  };

  const clickHandler = () => {
    setIsCustomizing(false);
  };

  return (
    // div is required here to support the Animation component
    <div>
      <Button
        className={`${styles.alignmentLeft} mr4 text-sm flex content-center`}
        color="black"
        data-e2e="done-customizing-button"
        onClick={clickHandler}
        ref={backButtonRef}
        visualStyle="textOnly"
      >
        <Icon className="pr5" path={chevronLeft} size="24px" />
        {formatMessage(messages.doneCustomizingLabel)}
      </Button>
      <ColumnsTemplate
        leftColumn={sliceCategoriesIntoColumns(0, firstColumnEndIndex)}
        rightColumn={sliceCategoriesIntoColumns(firstColumnEndIndex)}
      />
      <CallsToAction />
    </div>
  );
};

export default Customizations;
